module.exports = __webpack_public_path__ + "static/img/y57.2da1401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y57.jpg
// module id = IKaW
// module chunks = 1